<template>
  <div class="index-more">
    <div class="w1200 animate_top in index-more-box" style="display: block">
      <h2>{{ element.titleBarName }}</h2>
      <div class="index-more-list">
        <div
          class="index-more-item"
          v-for="(item, index) in showData"
          :key="index"
        >
          <a href="#">
            <img
              :src="isString(item.customField3) ? item.customField3 : item.customField3.contentImage | imgUrl"
              alt
            />
            <img
              v-if="!isString(item.customField3) && item.customField3.contentType == 'video'"
              class="video-block-play"
              src="https://mks.yybip.com/group1/M00/01/F7/CgoRDGSAPjeATLhuAAAHsdousik151.png"
            />
          </a>
          <h3>{{ item.customField1 }}</h3>
          <p>{{ item.customField2 }}</p>
          <a class="index-more-btn" href="#">{{ item.customField4.text }} →</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  buttonObject,
  contentObject
} from "@/modules/autoweb/config/elementObject.js";
export default {
  name: "MkXiangguanchanpinWeb",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      }
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    isString(value) {
      if (Object.prototype.toString.call(value) === "[object String]") {
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {
    showData: function() {
      return _.take(this.childItem.propsValue.data, 3)
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "标题",
          type: "text"
        },
        {
          code: "customField2",
          label: "描述",
          type: "text"
        },
        {
          code: "customField3",
          label: "素材",
          type: "content",
          contentType: "image,video",
          defaultType: "image",
          width: 376,
          height: 188,
          isMultiple: false
        },
        {
          code: "customField4",
          label: "按钮",
          type: "button"
        }
      ],
      data: [
        {
          customField1: "YonBIP | 产品1",
          customField2: "在此输入描述说明信息...",
          customField3: _.cloneDeep(contentObject),
          customField4: _.cloneDeep(buttonObject)
        },
        {
          customField1: "YonBIP | 产品2",
          customField2: "在此输入描述说明信息...",
          customField3: _.cloneDeep(contentObject),
          customField4: _.cloneDeep(buttonObject)
        },
        {
          customField1: "YonBIP | 产品3",
          customField2: "在此输入描述说明信息...",
          customField3: _.cloneDeep(contentObject),
          customField4: _.cloneDeep(buttonObject)
        }
      ]
    };
  }
};
</script>


<style lang="scss">
.index-more {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}
.index-more-box h2 {
  font-size: 30px;
  font-weight: bold;
  line-height: 26px;
  letter-spacing: 2px;
  color: #e31924;
  padding-top: 40px;
  text-align: center;
  padding-bottom: 40px;
  margin: 0 auto;
}
.index-more-list {
  padding: 0 20px;
  display: flex;
  justify-content: space-between;

  .index-more-item {
    flex: 0 0 260px;
    width: 260px;
    height: 360px;
    box-shadow: 0px 4px 8px 0px rgba(175, 175, 175, 10%);
    border-radius: 6px;
    transition: all 0.3s ease-in;

    a,
    a:link {
      display: block;
      text-decoration: none;
      cursor: pointer;
      color: #333;
      position: relative;
      width: 260px;
      height: 130px;
      img {
        width: 100%;
        height: 100%;
      }
      .video-block-play {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50px;
        height: 50px;
      }
    }

    h3 {
      font-size: 18px;
      font-weight: bold;
      line-height: 24px;
      letter-spacing: 1px;
      color: #333333;
      padding: 15px 25px 15px;
      margin: 0 auto;
    }
    p {
      height: 130px;
      overflow: hidden;
      font-size: 14px;
      line-height: 26px;
      letter-spacing: 1px;
      color: #6c6c6c;
      padding: 0 25px 30px;
      margin: 0 auto;
    }
    .index-more-btn {
      font-size: 14px;
      line-height: 26px;
      letter-spacing: 1px;
      color: #454343;
      padding-left: 25px;
    }
  }
}
</style>
